<wl-progressive-form-step-wrapper
  [title]="rendering?.fields?.personalDetailsTitle?.value"
  [subtitle]="rendering?.fields?.personalDetailsSubTitle?.value"
  [formState]="formState"
  [rendering]="rendering"
  [stepNumber]="trackStep.step"
  [stepName]="trackStep.stepName"
  [submitButtonText]="rendering?.fields?.personalDetailsNextButtonText?.value"
  [submitButtonIcon]="
    rendering?.fields?.personalDetailsNextButtonIcon?.fields?.value?.value
  "
  submitButtonAutomationId="submit-personal-details"
  [progressiveFormSelectorKey]="progressiveFormSelectorKey"
  [isReadonly]="isReadonly"
>
  <ng-template wlProgressiveFormBody>
    <span
      class="h6"
      wlCSCapture
      *scText="rendering?.fields?.salutationLabel"
    ></span>
    @if (salutationOptions) {
      <div class="row mb-2">
        <div class="col-12">
          <wl-radio
            [rendering]="rendering"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
            fieldName="geslacht"
            [sendValue]="false"
            [formsControl]="formState?.controls?.salutation"
            [radioItems]="salutationOptions"
            [inline]="true"
          ></wl-radio>
          @if (
            formState.controls.salutation?.isTouched &&
            formState.controls.salutation?.errors?.required &&
            rendering?.fields?.salutationRequiredError?.value
          ) {
            <wl-input-error
              [automationId]="'salutation-required-error'"
              [rendering]="rendering"
              [messageField]="rendering?.fields?.salutationRequiredError"
              [step]="trackStep.step"
              [stepName]="trackStep.stepName"
            ></wl-input-error>
          }
        </div>
      </div>
    }
    <div class="row mb-2">
      <div class="col-6">
        <wl-text
          wlAutocomplete="firstname"
          [rendering]="rendering"
          [step]="trackStep.step"
          [stepName]="trackStep.stepName"
          fieldName="voorletter"
          [sendValue]="false"
          [valueConverter]="_initialsConverter"
          [formsControl]="formState?.controls?.initials"
          [placeholder]="rendering?.fields?.initialsPlaceholder?.value || ''"
          [label]="rendering?.fields?.initialsLabel?.value"
        ></wl-text>
        @if (
          formState.controls.initials.isTouched &&
          formState.controls.initials.errors?.required &&
          rendering?.fields?.initialsRequiredError?.value
        ) {
          <wl-input-error
            [automationId]="'initials-required-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.initialsRequiredError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
      </div>
      <div class="col-6">
        <wl-text
          wlAutocomplete="prefix"
          [rendering]="rendering"
          [step]="trackStep.step"
          [stepName]="trackStep.stepName"
          fieldName="tussenvoegsel"
          [sendValue]="false"
          [formsControl]="formState?.controls?.prefix"
          [placeholder]="rendering?.fields?.prefixPlaceholder?.value || ''"
          [label]="rendering?.fields?.prefixLabel?.value"
        ></wl-text>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <wl-text
          wlAutocomplete="lastname"
          [rendering]="rendering"
          [step]="trackStep.step"
          [stepName]="trackStep.stepName"
          fieldName="achternaam"
          [sendValue]="false"
          [formsControl]="formState?.controls?.lastName"
          [placeholder]="rendering?.fields?.lastNamePlaceholder?.value || ''"
          [label]="rendering?.fields?.lastNameLabel?.value"
        ></wl-text>
        @if (
          formState.controls.lastName.isTouched &&
          formState.controls.lastName.errors?.required &&
          rendering?.fields?.lastNameRequiredError?.value
        ) {
          <wl-input-error
            [automationId]="'last-name-required-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.lastNameRequiredError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
        @if (
          formState.controls.lastName.isTouched &&
          formState.controls.lastName.errors?.pattern &&
          rendering?.fields?.lastNameInvalidError?.value
        ) {
          <wl-input-error
            [automationId]="'last-name-invalid-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.lastNameInvalidError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <wl-phone
          wlAutocomplete="phone"
          [rendering]="rendering"
          [step]="trackStep.step"
          [stepName]="trackStep.stepName"
          fieldName="telefoonnummer"
          [sendValue]="false"
          [formsControl]="formState?.controls?.phoneNumber"
          [tooltip]="rendering?.fields?.phoneNumberTooltip?.value || ''"
          [placeholder]="rendering?.fields?.phoneNumberPlaceholder?.value || ''"
          [label]="rendering?.fields?.phoneNumberLabel?.value"
        ></wl-phone>
        @if (
          formState.controls.phoneNumber.isTouched &&
          formState.controls.phoneNumber.errors?.required &&
          rendering?.fields?.phoneNumberRequiredError?.value
        ) {
          <wl-input-error
            [automationId]="'phone-number-required-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.phoneNumberRequiredError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
        @if (
          formState.controls.phoneNumber.isTouched &&
          formState.controls.phoneNumber.errors?.isPhoneNumber &&
          rendering?.fields?.phoneNumberInvalidError?.value
        ) {
          <wl-input-error
            [automationId]="'phone-number-invalid-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.phoneNumberInvalidError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
      </div>
    </div>
    @if (
      formState.userDefinedProperties?.showDateOfBirth &&
      formState.controls?.dateOfBirth
    ) {
      <div class="row mb-2">
        <div class="col-12">
          <wl-datepicker
            [rendering]="rendering"
            stepName="invullen"
            fieldName="geboortedatum"
            navigation="select"
            wlAutocomplete="bday"
            [formsControl]="formState.controls?.dateOfBirth"
            [label]="rendering?.fields?.dateOfBirth?.value"
            [startValidDate]="minimumDateOfBirth"
            [endValidDate]="maximumDateOfBirth"
          ></wl-datepicker>
          @if (state?.formState.controls.dateOfBirth | isInvalid) {
            @if (state?.formState.controls.dateOfBirth.errors.required) {
              <wl-input-error
                [messageField]="rendering?.fields?.dateOfBirthRequired"
                [rendering]="rendering"
              ></wl-input-error>
            }
            @if (
              state?.formState.controls.dateOfBirth.errors.overRange ||
              state?.formState.controls.dateOfBirth.errors.underRange
            ) {
              <wl-input-error
                [messageField]="rendering?.fields?.dateOfBirthInvalid"
                [rendering]="rendering"
              ></wl-input-error>
            }
          }
        </div>
      </div>
    }
    <div class="row mb-2">
      <div class="col-12">
        <wl-email
          wlAutocomplete="email"
          [rendering]="rendering"
          [step]="trackStep.step"
          [stepName]="trackStep.stepName"
          [sendValue]="false"
          fieldName="emailadres"
          [formsControl]="formState?.controls?.emailAddress"
          [placeholder]="
            rendering?.fields?.emailAddressPlaceholder?.value || ''
          "
          [tooltip]="rendering?.fields?.emailAddressTooltip?.value || ''"
          [label]="rendering?.fields?.emailAddressLabel?.value"
        ></wl-email>
        @if (
          formState.controls.emailAddress.isTouched &&
          formState.controls.emailAddress.errors?.required &&
          rendering?.fields?.emailAddressRequiredError?.value
        ) {
          <wl-input-error
            [automationId]="'email-address-required-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.emailAddressRequiredError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
        @if (
          formState.controls.emailAddress.isTouched &&
          formState.controls.emailAddress.errors?.isEmailAddress &&
          rendering?.fields?.emailAddressInvalidError?.value
        ) {
          <wl-input-error
            [automationId]="'email-address-is-email-address-error'"
            [rendering]="rendering"
            [messageField]="rendering?.fields?.emailAddressInvalidError"
            [step]="trackStep.step"
            [stepName]="trackStep.stepName"
          ></wl-input-error>
        }
      </div>
    </div>
  </ng-template>
  <ng-template wlProgressiveFormSummary>
    <div wlCSMask>
      <p class="mb-0">
        {{
          selectedSalutationOption(
            salutationOptions,
            formState?.value?.salutation
          )
        }}
        {{ formState?.value?.initials }}
        {{ formState?.value?.prefix }}
        {{ formState?.value?.lastName }}
      </p>
      <p class="mb-0">{{ formState?.value?.phoneNumber }}</p>
      @if (formState.userDefinedProperties?.showDateOfBirth) {
        <p class="mb-0">
          {{ formState?.value?.dateOfBirth }}
        </p>
      }
      <p class="mb-0">{{ formState?.value?.emailAddress }}</p>
    </div>
  </ng-template>
</wl-progressive-form-step-wrapper>
